<template>
	<div class="game-board" :class="{'inactive': !activeCycle}">
		<div class="board-row" v-for="row in rowCount" :key="row" v-if="rowCount">
			<Tile
				v-if="columnCount"
				v-for="column in columnCount"
				:key="row-column"
				ref="tiles"
				:catComponentType="catComponentType"
				:totalColumns="columnCount"
				:columnNumber="column"
				:style="{
					width: `${tileWidth}px`,
					height: `${tileHeight}px`,
				}"
			/>
		</div>
	</div>
</template>

<script>
import tileSizer from '@/mixins/tile-sizer';
import { mapState } from 'vuex';

export default {
	name: 'Board',
	mixins: [tileSizer],
	props: {
		stage: { default: null },
		fillTiles: { default: true },
		isReviewing: { default: false },
		catComponentType: { default: "Cat" },
	},
	provide() {
		return {
			scale: this.scale,
		};
	},
	computed: {
		...mapState({
			activeCycle: state => state.cycle.active,
			oldCats: state => state.cats.breeds.old,
			newCats: state => state.cats.breeds.new,
		}),
	},
	watch: {
		isReviewing(isReviewing, wasReviewing) {
			if (!isReviewing && wasReviewing && this.fillTiles) {
				this.populateTiles();
			}
		},
	},
	methods: {
		// populateBlockedTiles() {
		// 	this.$store.state.cats.breeds.dead.forEach((breedName) => {
		// 		this.$store.dispatch("fillTile", {
		// 			state: "death",
		// 			breed: breedName,
		// 		});
		// 	});
		// },
		populateTiles() {
			const spawnList = [];

			this.oldCats.forEach((breedName) => {
				spawnList.push({
					state: "old",
					breed: breedName,
				});
			});

			this.newCats.forEach((breedName) => {
				spawnList.push({
					state: "new",
					breed: breedName,
				});
			});

			this.$store.dispatch("createSpawner", { spawnList });
		},
	},
	mounted() {
		this.$nextTick(() => {
			if (this.fillTiles) {
				// this.populateBlockedTiles();
				this.populateTiles();
			}
		});
	},
	beforeDestroy() {
		this.$store.commit("deregisterAllTiles");
	},
};
</script>

<style lang="scss" scoped>
	.game-board {
		display: flex;
		width: 100%;
		height: 0;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		flex-grow: 1;
		pointer-events: none;
	}

	.board-row {
		display: flex;
		width: 100%;
		justify-content: space-around;
	}
</style>



// WEBPACK FOOTER //
// src/components/board/Board.vue